<div class="cald_dialog" #attributesDataTableDialog>
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="close()">&#xe03e;</button>
    <h2>{{'FormulaBuilder.AlertMsg.Attributes' | translate}}</h2>
  </div>
  <div class="cald_content">
    <div class="cpq-dialog-content-scroll">
      <cpq-datatable [showColumnSelection]='false' [service]='service' [columns]='columns' (onRowsChanged)='onRowsChanged($event)'
        (onRowChanged)='onRowChanged($event)' [filter]='filter' [scrollbarH]="'false'"></cpq-datatable>
    </div>
  </div>

  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" id="addSelectedAttribute" class="btn btn-primary fiori3-btn-primary" (click)="save()">{{'Admin.Msg.AddSelected' | translate}}</button>
    <button type="button" id="cancelAttributeSelection" class="btn btn-tertiary fiori3-btn-tertiary" tabindex="-1" (click)="close()">{{'Msg.Cancel' | translate}}</button>
  </div>
</div>
